import { MouseEventHandler, ReactNode, useEffect, useRef, useState } from "react";
import { DivSurveyMultiSelectOptionContainer, ImgSurveyMultiSelectOption, PSurveyMultiSelectOption, SubtitleSurveyLabel } from "theme/survey";
import { Options } from "views/raffles/types";

export interface MultiSelectProps {
  title: ReactNode;
  items?: Options[];
  onChange: (key: string, selected: string[]) => void;
}

const MultiSelect = (props: MultiSelectProps) => {
  const [selected, setSelected] = useState<string[]>([]);
  const titleRef = useRef<HTMLHeadingElement>(null);

  const onClick: MouseEventHandler<HTMLDivElement> = (event) => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'SURVEY - Seleccionar encuesta', value: '10' })
    const itemId = event.currentTarget.id as string;
    const isSelected = selected.includes(itemId);
    // if (props.items?.length === 3) {
    //   return setSelected([itemId]);
    // }

    if (isSelected) {
      setSelected((selectedItems) => selectedItems.filter((id) => id !== itemId));
    } else {
      const newSelectedList = [...selected];

      if (newSelectedList.length >= 3) {
        newSelectedList.shift();
      }

      newSelectedList.push(itemId);

      setSelected(newSelectedList);
    }
  };

  useEffect(() => {
    props.onChange(titleRef.current?.innerText.replace("\n", " ").toLocaleLowerCase() || "", selected);
  }, [selected, titleRef]);

  return (
    <>
      <div className="p-2 w-full">
        <SubtitleSurveyLabel className="font-black text-2xl text-center md:text-3xl" ref={titleRef}>
          {props.title}
        </SubtitleSurveyLabel>
      </div>
      <div className={`grid justify-center my-2 gap-2 md:mx-auto w-full`} style={{ gridTemplateColumns: props.items.length === 3 ? 'repeat(3, minmax(0, 1fr))' : 'repeat(2, minmax(0, 0.35fr))' }}>
        {props.items &&
          props.items.map(({ id, src, option }) => {
            const key = `${id}`;
            const isSelected = selected.includes(key);

            return (
              <div
                key={key}
                className="aspect-square flex items-end relative"
                id={String(id)}
                data-kind={id}
                onClick={onClick}
              >
                <DivSurveyMultiSelectOptionContainer
                  isSelected={isSelected}
                  className={`w-full h-full absolute top-0 left-0 border-2 transition-colors ${isSelected ? "border-black" : "border-transparent"} relative`}
                >
                  <PSurveyMultiSelectOption className="font-bold absolute bottom-1 mx-auto text-center w-full flex items-center justify-center">{option}</PSurveyMultiSelectOption>
                  <ImgSurveyMultiSelectOption src={src} alt={option} className="w-full aspect-square min-h-6" />
                </DivSurveyMultiSelectOptionContainer>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default MultiSelect;
